import { render, staticRenderFns } from "./TestVoiceText.vue?vue&type=template&id=41c8f9ae&"
import script from "./TestVoiceText.vue?vue&type=script&lang=js&"
export * from "./TestVoiceText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports